import React from 'react'
import classes from "./LeadersBoard.module.css"

interface LeadersBoardType  {
    leadersData: string[];
}

const LeadersBoard: React.FC<LeadersBoardType> = ({ leadersData }) => {

  return (
      <div className={classes["leaders-board-bg"]}>
          <ul  className={classes["lb-root"]}>
              {leadersData.map(name => <li key={name}> {name} </li>) }
          </ul>
      </div>
  );
}

export default LeadersBoard